<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Theme</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="#f4f5f7">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <!-- <v-text-field
                    v-model="user.address"
                    name="address"
                    prepend-icon="mdi-google-maps"
                    label="Address"
                    v-validate="'required'"
                    :error="
                      errors.first('address') != null ||
                      serverSideErrors.address != null
                    "
                    :error-messages="
                      errors.first('address') || serverSideErrors.address
                    "
                  ></v-text-field> -->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <h3>Primary Color</h3>
                  <v-color-picker
                    v-model="theme_primary_color"
                    dot-size="25"
                    hide-canvas
                    show-swatches
                    swatches-max-height="200"
                    mode="hexa"
                    hide-mode-switch
                  ></v-color-picker>
                </v-col>
                <v-col cols="12" xs="12" sm="6" md="6">
                  <h3>Button Color</h3>
                  <v-color-picker
                    v-model="theme_button_color"
                    dot-size="25"
                    hide-canvas
                    show-swatches
                    swatches-max-height="200"
                    mode="hexa"
                    hide-mode-switch
                  ></v-color-picker>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="updateTheme"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loading: false,
      user: {},
      theme_primary_color: '',
      theme_button_color: '',
      serverSideErrors: [],
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    updateTheme() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          _self.$axios
            .put("/societyadmin/theme",{
              theme_primary_color : this.theme_primary_color,
              theme_button_color : this.theme_button_color
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                let user = localStorage.getItem("user");
                user = JSON.parse(user);
                user.theme_primary_color = this.theme_primary_color;
                user.theme_button_color = this.theme_button_color;
                localStorage.setItem("user",JSON.stringify(user));

                this.$vuetify.theme.themes.light.primary = this.theme_primary_color;
                this.$vuetify.theme.themes.dark.primary = this.theme_primary_color;
                this.$vuetify.theme.themes.light.secondary = this.theme_button_color;
                this.$vuetify.theme.themes.dark.secondary = this.theme_button_color;

                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.theme_primary_color = this.user.theme_primary_color;
    this.theme_button_color = this.user.theme_button_color;
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>